import React from "react";
import { PageTitle } from "@/components/DashUI";
import CommissionCalculator from "@/components/CommissionCalculator";

export default function CalculatorPage() {
  return (
    <div>
      <PageTitle title="Commission Calculator" subtitle="Model illustrative placement economics for any service" />
      <CommissionCalculator />
    </div>
  );
}
